export default {"src":"/_next/static/image/public/images/flags/flag_373.b35fe5898be5e156482a534becb4a2db.svg","height":16,"width":24};